import { Notifier } from "@airbrake/browser";
import z from "zod";

const AirbrakeCredSchema = z.object({
  projectId: z.number(),
  projectKey: z.string(),
  environment: z.string(),
});

const validCreds = (data: unknown): data is z.infer<typeof AirbrakeCredSchema> => {
  return AirbrakeCredSchema.safeParse(data).success;
};

export default function createAirbrake() {
  const airbrakeCreds = {
    projectId: Number(process.env.REACT_APP_AIRBRAKE_PROJECT_ID),
    projectKey: process.env.REACT_APP_AIRBRAKE_PROJECT_KEY,
    environment: process.env.REACT_APP_ENV,
  };

  if (!validCreds(airbrakeCreds)) {
    console.warn("Airbrake creds are invalid or incomplete.");
    return null;
  }

  return new Notifier(airbrakeCreds);
}
